import styled from 'styled-components';

const info = styled.button`
  display: flex;
  background: transparent;
  border: none;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
`;

const Button = {
  Info: info,
};

export default Button;
